import React from 'react';
import styled from 'styled-components';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { Calendar } from 'primereact/calendar';
import { Typography } from '../Typography';
import { InfoTooltip } from '../Tooltip/InfoTooltip';
import CalendarIcon from "assets/calendar.svg";

interface FormDateProps extends FieldProps<Date, FieldRenderProps<Date>> {
    id?: string;
    label?: string;
    placeholder?: string;
    tooltip?: React.ReactNode;
    initialValue?: Date;
    required?: boolean;
    icon?: React.ReactNode;
}

export const FormDate: React.FC<FormDateProps> = props => {
    return (
        <Field<Date>
            type="date"
            {...props}
            initialValue={props.initialValue}
            render={({ input }) => (
                <Container id={props.id}>
                    <Label>
                        <Typography variant="body6">
                            <label htmlFor={props.name}>
                                {props.label} {props.required && <span style={{color:'#6777FF'}}>*</span>}
                            </label>
                        </Typography>
                        {props.tooltip && (
                            <InfoTooltip
                                name={`date-tooltip-${props.name}`}
                                tooltip={props.tooltip}
                            />
                        )}
                    </Label>
                    <StyledCalendar
                        {...input}
                        value={input.value || null}
                        onChange={e => input.onChange(e.value)}
                        showIcon
                        icon={<CalendarIcon />}
                        placeholder={props.placeholder}
                    />
                </Container>
            )}
        />
    );
};


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const StyledCalendar = styled(Calendar)`
    border: 1px solid #E9E9E9;
    border-radius: 8px;

    .p-datepicker-trigger {
        background-color: transparent;
        border: none;

        &:hover {
            background-color: rgba(103, 119, 255, 0.1);
        }

        &:focus {
            box-shadow: none;
        }
    }

    .p-inputtext {
        font-size: 13px;
        font-weight: 500;
        padding: 8px 12px;
        border: none;
        box-shadow: none !important;
    }
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;